<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      opacity="0.900000036"
    >
      <g transform="translate(-239, -313)">
        <g id="Kort" transform="translate(239, 312)">
          <g id="Group" transform="translate(0, 1)">
            <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
            <line
              id="Path"
              x1="3"
              y1="21"
              x2="21"
              y2="21"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></line>
            <line
              id="Path"
              x1="9"
              y1="8"
              x2="10"
              y2="8"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></line>
            <line
              id="Path"
              x1="9"
              y1="12"
              x2="10"
              y2="12"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></line>
            <line
              id="Path"
              x1="9"
              y1="16"
              x2="10"
              y2="16"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></line>
            <line
              id="Path"
              x1="14"
              y1="8"
              x2="15"
              y2="8"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></line>
            <line
              id="Path"
              x1="14"
              y1="12"
              x2="15"
              y2="12"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></line>
            <line
              id="Path"
              x1="14"
              y1="16"
              x2="15"
              y2="16"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></line>
            <path
              id="Path"
              d="M5,21 L5,5 C5,3.8954305 5.8954305,3 7,3 L17,3 C18.1045695,3 19,3.8954305 19,5 L19,21"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
